import {Route} from "react-router-dom";
import {lazy} from "react";

export const asyncRoute = (path = '',
                           componentImportFunc,
                           exact = false) =>
  <Route exact={exact} path={path} component={lazy(componentImportFunc)} key={Math.random()}/>;